import { apiUrl } from "@/main"

export function getUrl(url) {
    if (url && !url.startsWith('http')) {
        const base = apiUrl().replace(/\/+$/, '')
        
        // 确保 url 以 '/' 开头，便于后续拼接
        const normalizedUrl = url.startsWith('/') ? url : '/' + url
        
        // 如果 url 中不包含 'media'，则插入 '/media'
        const finalPath = normalizedUrl.includes('media') 
            ? normalizedUrl 
            : '/media' + normalizedUrl
        
        return base + finalPath
    }
    return url
}